import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { AlertService } from '../../providers/alert-service';
import { ModalCargoPage } from '../modais/modal-cargo/modal-cargo';
import { CargoService } from '../../providers/cargo-service';
import { ModulosController } from "../modulos/modulos-controller";
import { GestaoPcaService } from "../../providers/gestao-pca-service";
import { UsuarioService } from "../../providers/usuario-service";
import { MenuService } from "../../providers/menu-service";
import { PessoalService } from "../../providers/pessoal-service";
import { FileService } from "../../providers/file-service";

@Component({
  selector: 'page-cargo',
  templateUrl: 'cargo.html',
  providers: [
    CargoService,
    PessoalService
  ]
})
export class CargoPage extends ModulosController {

  listaCargo: any = [];
  analise: any;
  tiposArquivosAceitos: string = "application/xls";
  dadosImportados: any[];
  idSecaoPagina: string = "109";
  loading: boolean = true;
  desabilitarBotaoCarregar: boolean = true;
  selecionarTodosChecked = false;
  
  page1: number = 1;
    
  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public cargoService: CargoService,
    public gestaoPcaService: GestaoPcaService,
    public modalCtrl: ModalController,
    private fileService: FileService,
    public pessoalService: PessoalService,
    public alertService: AlertService,
    public usuarioService: UsuarioService,
    private menuService: MenuService) {

    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.analise = this.navParams.get('analise');
    this.carregarPagina();

  }

  carregarPagina() {
    this.cargoService.listarCargo(11).subscribe(data => {
      this.listaCargo = data;

      this.desabilitarBotaoCarregar = this.listaCargo.length > 0;
      this.selecionarTodosChecked = false;

      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  salvar() {

    this.loading = true;
    this.cargoService.salvarLista(this.listaCargo).subscribe(data => {
        
      this.cargoService.salvarAnaliseRelacaoCargos(this.gestaoPcaService.getPCA().id, this.analise.cdAnalise).subscribe(data => {
          this.alertService.mostraAlerta("", "Salvo com sucesso.");
          this.carregarPagina();
          this.loading = false;
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
          this.loading = false;
        });

      }, error => {

      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
      this.loading = false;

    });
  }

  finalizar() {
    
    this.loading = true;
    this.cargoService.salvarLista(this.listaCargo).subscribe(data => {

      this.cargoService.finalizarAnaliseRelacaoCargos(this.gestaoPcaService.getPCA().id, this.analise.cdAnalise).subscribe(data => {
        this.alertService.mostraAlerta("", "Finalizado com sucesso.");
        this.voltarParaPessoal();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar: " + error.mensagem);
        this.loading = false;
      });

    }, error => {

      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
      this.loading = false;

    });
  }

  inserirNovoCargo() {

    let parametroEnviado = this.cargoService.criaCargo();
    this.mostrarModal("Cadastro de Cargo", parametroEnviado);
    this.selecionarTodosChecked = false;
  }

  deletar(cargo:any) {
    this.alertService.mostraModalConfirmacao("Excluir cargo",
      "Confirma a exclusão do cargo ?", retorno => {
        if (retorno) {
          if(cargo != undefined && cargo.idCargo > 1){
            this.cargoService.deletarCargo(cargo.idCargo).subscribe(data => {
              this.carregarPagina();
              this.alertService.mostraAlerta("Deletar", "Cargo removido com sucesso !");
            }, error => {
              console.log(JSON.stringify(error));
              this.alertService.mostraAlerta("Deletar", "Ocorreu um erro ao remover o cargo !");
            });
          }
        }else {
        }
      });
  }

  excluirSelecionados(){

    let qtdeSelecionados = 0; 
    this.listaCargo.forEach(item => qtdeSelecionados += item.checked);
    
    if(qtdeSelecionados == 0) {
        this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
        return;
    }

    let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

    this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
        "Deseja continuar com a exclusão de " 
            + registrosTexto + "<br/>" 
            + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
        callback => {            
            if (callback) {
                this.loading = true;
                                    
                let listaId = this.listaCargo
                    .filter(item => item.checked)
                    .map(item => item.idCargo);
                
                this.cargoService.deletarLista(listaId).subscribe(data => {
                    this.loading = false;
                    this.carregarPagina();
                    this.alertService.mostraAlerta("", data.mensagem);
                }, error => {
                    this.loading = false;
                    this.carregarPagina();
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                });
            }
        }
    );        
}

  editarCargo(parametroEnviado) {
    this.mostrarModal("Edição de Cargo", parametroEnviado);
    this.selecionarTodosChecked = false;
  }

  mostrarModal(titulo, parametroEnviado) {
    let modal = this.modalCtrl.create(ModalCargoPage, { param1: titulo, param2: parametroEnviado });
    modal.onDidDismiss(retornoModal => {
      this.carregarPagina();
    });
    modal.present();
  }

  voltarParaPessoal() {
    this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
  }

  downloadDoModelo() {
    let idTemplate = 5;
    this.fileService.downloadModeloCargaPessoal(idTemplate);
  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", 
      callback => {
        if (callback) {
          this.loading = true;
          this.fileService.cargaRelacaoCargos(event).subscribe(
          data => {
            this.inputFileCMVar.nativeElement.value = "";
                     
            for (let i = 0; i < data.length; i++) {
              let cargoTemplate = data[i];
              if (this.listaCargo.findIndex(cargo => cargo.nomeCargo.trim() === cargoTemplate.nomeCargo.trim()
                    && cargo.flAtivo === cargoTemplate.flAtivo) == -1) {
                this.listaCargo.push(cargoTemplate);
              } 
            }           
           
            this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
            this.loading = false;
          }, 
          error => {
            this.inputFileCMVar.nativeElement.value = "";
            this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
            this.loading = false;
          });
        } else {
          this.inputFileCMVar.nativeElement.value = "";
        }
    });
  }


  importarCargosAnoAnterior() {
    this.alertService.mostraModalConfirmacao("Importar cargos do ano anterior", 
        "Deseja continuar a importação dos cargos do ano anterior?", 
        callback => {            
          if (callback) {
          this.loading = true;
            this.cargoService.carregarCargosAnoAnterior(11).subscribe(data => {
                this.listaCargo = data;
                this.desabilitarBotaoCarregar = this.listaCargo.length > 0;
                this.loading = false;
                this.alertService.mostraAlerta("", "Importação de cargos finalizada!");
            }, error => {;
                this.desabilitarBotaoCarregar = false;
                this.loading = false;                
                this.alertService.mostraAlerta("Ocorreu um erro ao carregar: ", error.mensagem);
            });
          }
        }
    );
  }

  selecionarTodos(){
    setTimeout(()=>{
        this.listaCargo.forEach(
            item => item.checked = this.selecionarTodosChecked);            
    });
}

selecionarItem(){
    const totalItems = this.listaCargo.length;
    let checked = 0;
    this.listaCargo.map(obj => {
        if (obj.checked) checked++;
    });
    this.selecionarTodosChecked = checked == totalItems;
}


}



// WEBPACK FOOTER //
// ./src/pages/cargo/cargo.ts